<template>
  <v-app id="inspire">
    <router-view/>
    <toast/>
  </v-app>
</template>

<script>
import Toast from "@/components/Toast";
export default {
  name: "App",
  components: {Toast},
  beforeMount() {
    console.log(localStorage.token);
    if (!localStorage.token) {
      this.$router.push("/login").catch(() => {});
    }
  }
}
</script>
<style>
.search {
  max-width: 250px !important;
}
</style>